import { Controller } from "stimulus"

export default class extends Controller {
  show(event) {
    event.preventDefault()
    document.dispatchEvent(new CustomEvent("onboarding:show"))
  }
}
